module.exports = __webpack_public_path__ + "static/pay-by-link-feature-e1b88c7ecffb23f480bda68b50448b38.svg";